import * as React from 'react'

import { AddIcon } from '../icons'
import { A } from './A'

export class AddToCalendarButton extends React.Component<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  {}
> {
  public render() {
    const { href, children, ...rest } = this.props
    return (
      <A
        href={href || '#'}
        icon={<AddIcon w={20} h={20} fill="#fff" />}
        {...rest}
      >
        {children}
      </A>
    )
  }
}

// const AddToCalendarButtonContainer = styled.div`
//   display: flex;
//   justify-content: flex-start;
//   min-width: 236px;
//   margin: 0 0 25px 0;
//   @media all and (max-width: 600px) {
//     width: 100%;
//   }
// `
// const Children = styled.span`
//   padding: 5px 15px;
//   text-align: center;
//   color: #fff;
// `

// const A = styled.a`
//   padding: 5px 15px;
//   text-align: center;
//   border: 1px solid #fff;
//   background: transparent;
//   display: flex;
//   text-decoration: none;
//   align-content: space-between;
//   align-items: center;
//   text-transform: uppercase;
//   &:hover {
//     background: #fff;
//     color: #000;
//     cursor: pointer;
//     text-decoration: none;
//     svg {
//       path {
//         fill: #000;
//       }
//     }
//     ${Children} {
//       color: #000;
//     }
//   }
//   &:focus,
//   &:active {
//     outline: ${theme.outline};
//   }
// `
